import React from 'react';
import { withRouter } from "react-router-dom";
import { AddressLink, PhoneLink } from "../ecosystem/mybswh"

const PharmacyTileContact = ({
    address,
    phone
}) => {

    return (<div className="row pharmacy-tile-contact">
        <div className="col pharmacy-tile__address">
            <AddressLink
                address={address}
                street1Key="StreetAddress"
                cityKey= "City"
                stateKey= "State"
                zipKey= "Zip"
            />
        </div>
        <div className="col pharmacy-tile__phone">
            <PhoneLink phone={phone} />
        </div>
    </div>);
}

export default withRouter(PharmacyTileContact);
